import Routes from './Routes'
import Modal from 'react-modal'

Modal.setAppElement('#root')

function App() {
	return (
		<div>
			<Routes />
		</div>
	)
}

export default App
